import { render } from "./DayOverview.vue?vue&type=template&id=5351c72d&scoped=true"
import script from "./DayOverview.vue?vue&type=script&lang=js"
export * from "./DayOverview.vue?vue&type=script&lang=js"

import "./DayOverview.vue?vue&type=style&index=0&id=5351c72d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5351c72d"]])

export default __exports__